/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-target-blank */
const React = require('react');
const CarouselSnapped = require('@andes/carousel-snapped');
const { Pill } = require('@andes/badge');
const Card = require('@andes/card');
const { CardHeader, CardContent, CardFooter } = require('@andes/card');
const { getEventTracker } = require('../../../../../../../utils/event-tracker');

const { CarouselSnappedSlide } = CarouselSnapped;

const CarouselCardDesktopStandar = ({ index,
  pillText,
  title,
  url,
  linkDescription,
  tracking,
  label,
  iconCard }) => {
  const Tracker = getEventTracker();

  const sendToMelidata = (data) => {
    Tracker.melidata.send('/developers/click_livedemo', {
      demo: data,
    }, {
      autoDocsRefInfo: true,
    });
  };

  const setTrack = (event) => {
    Tracker.send('mpdevelopers/click_livedemo', event);
    sendToMelidata(event);
  };

  return (
    <CarouselSnappedSlide
      className="demonstration-card"
      index={index}
      key={`carousel__slide ${index}`}
    >
      <Card shadow="flat" className="demonstration-card-container" animated>
        <CardHeader className="demonstration-card-header" showBorder={false}>
          <>
            {iconCard}
          </>
        </CardHeader>
        <CardContent className="demonstration-card-content">
          <Pill className="demonstration-card-pill" color="gray" hierarchy="quiet" size="small"> {pillText} </Pill>
          <p className="demonstration-card-content-title">{title}</p>
        </CardContent>
        <CardFooter className="demonstration-card-footer" link={{ href: url, title: label, text: linkDescription, icon: true, onClick: () => { setTrack(tracking); } }} showBorder={false} />
      </Card>

    </CarouselSnappedSlide>
  );
};

module.exports = CarouselCardDesktopStandar;
